import PointDeCollecteFormWrapper from "../../components/pointsDeCollecte/PointDeCollecteFormWrapper";

const PointDeCollecteEdit = () => {
  return <PointDeCollecteFormWrapper action="edit" />;
};

export default PointDeCollecteEdit;
